import { useEffect, useRef } from 'react';
import type { useStudioDraft } from '../use-studio-draft';
import type { Task } from './tasks';
import './recovery-dialog.css';
import { recoveryNotice } from '../recovery-notice';

export function RecoveryDialog({ storage, onLoadLatest, onInspect }: {
  storage: ReturnType<typeof useStudioDraft>; onLoadLatest: () => void; onInspect: (task: Task) => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const notice = recoveryNotice(storage.issues, storage.draft);
  useEffect(() => {
    const element = dialog.current;
    if (!storage.reviewOpen || !element) return;
    const previous = document.activeElement;
    element.showModal();
    return () => {
      element.close();
      if (previous instanceof HTMLElement && previous.isConnected && previous !== document.body && !element.contains(previous)) previous.focus();
      else (document.querySelector<HTMLButtonElement>('.project-heading .recovery-review') ?? document.querySelector<HTMLButtonElement>('.header-review'))?.focus();
    };
  }, [storage.reviewOpen]);
  return <dialog ref={dialog} className="studio-recovery-dialog" aria-labelledby="studio-recovery-title" aria-describedby="studio-recovery-description"
    onKeyDown={event => event.stopPropagation()} onCancel={event => { event.preventDefault(); storage.closeReview(); }}>
    <div className="recovery-content">
    <h2 id="studio-recovery-title">{notice.title}</h2>
    <p id="studio-recovery-description">Your original settings stay saved until you apply a change.</p>
    <ul className="recovery-issues">{notice.changes.map((change, index) => <li key={index}>
      <h3>{change.label}</h3><p>{change.summary}</p>
    </li>)}</ul>
    {storage.validationIssue && <div role="alert"><p>{storage.validationIssue.message}</p>
      <button type="button" onClick={() => { storage.closeReview(); onInspect(storage.validationIssue!.target); }}>Check affected settings</button></div>}
    {storage.reviewError && <div role="alert"><p>{storage.reviewError}</p><p>{storage.message}</p></div>}
    {storage.conflict && <div role="alert"><p>Studio settings changed in another tab. Load those settings or keep your current edits before accepting.</p>
      <div className="recovery-actions"><button type="button" onClick={onLoadLatest}>Load saved settings</button>
        <button type="button" onClick={storage.keepCurrent}>Keep current edits</button></div></div>}
    </div>
    <footer className="recovery-footer"><button type="button" autoFocus onClick={storage.closeReview}>Keep editing</button>
      <button type="button" className="primary" disabled={storage.conflict} onClick={storage.acceptRecovered}>{notice.action}</button></footer>
  </dialog>;
}
